// Import plugin.
import React from 'react';
import ReactDOM from 'react-dom';
import OutsideClickHandler from 'react-outside-click-handler';
import IScroll from "iscroll";
import Stickyfill from "stickyfilljs";
import Selector from "./Selector";

let tmpObj = {};
let scrollContainers = [];
class Panel extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      listHeight: 40,
      orderIsOpen: false,
      yearIsOpen: false,
      monthIsOpen: false,
      filterIsOpen: false
    };
    this.openClose = this.openClose.bind(this);
  }
  
  componentDidMount(){
    // To fix when ios touch activate for react-outside-click-handler.
    if ('ontouchstart' in document.documentElement) {
      document.body.style.cursor = 'pointer';
    }
    // Stichky polyfill for IE11.
    const STICKY_EL = document.getElementById("controler__panel");
    Stickyfill.add(STICKY_EL);
  }
  
  
  componentDidUpdate(){
    // Define iscroll.
    if(scrollContainers.length === 0){
      const SCROLLERS = document.getElementsByClassName("select-btn__selector__scroller");
      for(let i = 0; i < SCROLLERS.length; i ++){
        SCROLLERS[i].addEventListener("touchmove", (e) => {
          e.preventDefault();
        }, {passive: false});
        scrollContainers[i] = new IScroll(SCROLLERS[i], {
          mouseWheel: true,
          scrollbars: true,
          interactiveScrollbars: true,
          freeScroll: true,
          click:true
        });
      }
    }
  }
  
  openClose(e){
    const GET_CONTENT = e.currentTarget.getAttribute("data-content");
    
    if(!this.state[GET_CONTENT] + "IsOpen"){
      this.setState({ [GET_CONTENT + "IsOpen"]: true });
    }
    
    Object.keys(this.state).forEach((f) => {
      if(this.state[f] && f.split("IsOpen").length !== 1){
        this.setState({ [f]: false });
      }
    });
  }
  
  pickContentName(e){
    const LIST_NAME = e.currentTarget.getAttribute("data-content");
    switch(e.type){
      case "mouseenter":
        if(!this.state.clickable){
          if(!this.state.defaultText){
            this.setState({
              defaultText: this.state.text
            });
          }
          
          this.setState({
            text: LIST_NAME
          });
        }
        break;
        
      case "mouseleave":
        if(!this.state.clickable){
          this.setState({ text: this.state.defaultText });
        }
        break;
      
      case "click":
        
        // Fix scroll position.
        const SCROLL_POS = document.documentElement.scrollTop || document.body.scrollTop;
        const GET_BOUNDARY = () => {
          var myMain = document.getElementById("cards");
          var rect = myMain.getBoundingClientRect();
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          return rect.top + scrollTop;
        }
        if(GET_BOUNDARY() < SCROLL_POS){
          window.scrollTo(0, GET_BOUNDARY());
        }
        
        // Get values.
        const parentTitle = e.currentTarget.parentNode.parentNode.parentNode.parentNode.getAttribute("data-content");
        if(LIST_NAME !== "all"){
          tmpObj[parentTitle] = LIST_NAME;
        }else{
          delete tmpObj[parentTitle];
        }
        this.setState({
          defaultText: LIST_NAME,
          text: LIST_NAME,
          clickable: true
        });
        
        this.props.handle(tmpObj);
        setTimeout(() => {
          this.setState({
            clickable: false
          });
        }, 200);
        break;
    }
  }
  
  render(){
    return(
      <div id="controler">
        <div id="controler__panel" className="controler__panel">
          <OutsideClickHandler onOutsideClick={ () => { this.setState({ orderIsOpen: false }); } }>
            <Order listHeight={ this.state.listHeight } isOpen={ this.state.orderIsOpen } openClose={ this.openClose } pickContentName={ this.pickContentName } handle={ this.props.panelHandle }  />
          </OutsideClickHandler>
          <OutsideClickHandler onOutsideClick={ () => { this.setState({ yearIsOpen: false }); } }>
            <Year listHeight={ this.state.listHeight } isOpen={ this.state.yearIsOpen } openClose={ this.openClose } pickContentName={ this.pickContentName } list={ this.props } handle={ this.props.panelHandle }  />
          </OutsideClickHandler>
          <OutsideClickHandler onOutsideClick={ () => { this.setState({ monthIsOpen: false }); } }>
            <Month listHeight={ this.state.listHeight } isOpen={ this.state.monthIsOpen } openClose={ this.openClose } pickContentName={ this.pickContentName } handle={ this.props.panelHandle }  />
          </OutsideClickHandler>
          <OutsideClickHandler onOutsideClick={ () => { this.setState({ filterIsOpen: false }); } }>
            <Filter listHeight={ this.state.listHeight } isOpen={ this.state.filterIsOpen } list={ this.props } openClose={ this.openClose } pickContentName={ this.pickContentName } handle={ this.props.panelHandle }  />
          </OutsideClickHandler>
        </div>
      </div>

    );
  }
}

class Order extends  React.Component{
  constructor(props){
    super(props);
    this.state = {
      isOpen: false,
      defaultText: "",
      list: ["新しい順", "古い順"],
      text: "　",
      clickable: false
    }
    this.pickContentName = props.pickContentName.bind(this);
    this.openClose = props.openClose.bind(this);
  }
  
  componentDidMount(){
    this.setState({ text: this.state.list[0] });
  }
  
  render(){
    return(
      <Selector listHeight={ this.props.listHeight } uniqueClass={ "sort" } 
      dataContent={ "order" } openClose = { this.openClose } isOpen = { this.props.isOpen } 
      text = { this.state.text } list = { this.state.list } pickContentName = { this.pickContentName } />
    );
  }
}

class Year extends  React.Component{
  constructor(props){
    super(props);
    this.state = {
      isOpen: false,
      defaultText: "",
      list: [],
      text: "　",
      clickable: false
    }
    this.pickContentName = props.pickContentName.bind(this);
    this.openClose = props.openClose.bind(this);
  }
  
  componentDidMount(){
    this.setState({ text: this.state.list[0] });
  }
  
  UNSAFE_componentWillReceiveProps(nextProps){
    if(this.state.text === void(0)){
      let tmp = [];
      Object.keys(nextProps.list["jsonData"]).forEach((e) => {
        tmp[0] = ("all");
        tmp.push(nextProps.list["jsonData"][e].year);
      });
      
      tmp = tmp.filter((x, i, self) => {
        return self.indexOf(x) === i;
      });
      
      this.setState({
        list: tmp,
        text: tmp[0]
      });
    }
  }
  
  render(){
    return(
      <Selector listHeight={ this.props.listHeight } uniqueClass={ "year" } 
      dataContent={ "year" } openClose = { this.openClose } isOpen = { this.props.isOpen } 
      text = { this.state.text } list = { this.state.list } pickContentName = { this.pickContentName } />
    );
  }
}

class Month extends  React.Component{
  constructor(props){
    super(props);
    this.state = {
      isOpen: false,
      defaultText: "",
      list: ["all", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      text: "　",
      clickable: false
    }
    this.pickContentName = props.pickContentName.bind(this);
    this.openClose = props.openClose.bind(this);
  }
  
  componentDidMount(){
    this.setState({ text: this.state.list[0] });
  }
  
  render(){
    return(
      <Selector listHeight={ this.props.listHeight } uniqueClass={ "month" } 
      dataContent={ "month" } openClose = { this.openClose } isOpen = { this.props.isOpen } 
      text = { this.state.text } list = { this.state.list } pickContentName = { this.pickContentName } />
    );
  }
}

class Filter extends  React.Component{
  constructor(props){
    super(props);
    this.state = {
      isOpen: false,
      defaultText: "",
      list: [],
      text: "　",
      clickable: false
    }
    this.pickContentName = props.pickContentName.bind(this);
    this.openClose = props.openClose.bind(this);
  }
  
  UNSAFE_componentWillReceiveProps(nextProps){
    if(!this.state.list.length){
      let tmp = [];
      Object.keys(nextProps.list["jsonData"]).forEach((e) => {
        nextProps.list["jsonData"][e].filter.forEach((f) => {
          tmp[0] = "all";
          tmp.push(f);
        });
      });
      tmp = tmp.filter((x, i, self) => {
        return self.indexOf(x) === i;
      });
      this.setState({
        list: tmp,
        text: tmp[0]
      });
    }
  }
  
  render(){
    return(
      <Selector listHeight={ this.props.listHeight } uniqueClass={ "sort" } 
      dataContent={ "filter" } openClose = { this.openClose } isOpen = { this.props.isOpen } 
      text = { this.state.text } list = { this.state.list } pickContentName = { this.pickContentName } />
    );
  }
}

export default Panel;